import type { AllAnalyticsEvents } from "@shared/models/analytics/all"

export interface Narrative {
  title?: string | null
  titleForAnalytics?: string | null
  activity?: Record<string, any> | null
  description?: string | null
  context?: Record<string, any> | null
  newAnalyticsEvents?: Array<AllAnalyticsEvents>
  url?: string | null
  verbForStream?: string | null
  isQuiet?: boolean | null
}

export default function (attrs: Partial<Narrative>): Narrative {
  return {
    title: attrs.title || null,
    titleForAnalytics: attrs.titleForAnalytics || null,
    activity: attrs.activity || null,
    description: attrs.description || null,
    context: attrs.context || null,
    newAnalyticsEvents: attrs.newAnalyticsEvents || [],
    url: attrs.url || null,
    verbForStream: attrs.verbForStream || null,
    isQuiet: attrs.isQuiet || null,
  }
}
